// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"66":"90e90046","325":"7f5cff2d","532":"591c0d74","626":"5fd2cf23"}[chunkId] + ".css";
};